import styled from 'styled-components';
import { brand, white } from 'styles/Colors';

export const GameCardWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.64);
  border-radius: 5px;
  text-align: center;
  color: ${white};
  cursor: default;
`;

export const BackfieldLink = styled.a`
  &:hover {
    color: ${brand};
  }
`;

export const Text = styled.div`
  margin-top: 26px;
  font-family: Lato;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

export const Title = styled.div`
  margin-top: 109px;
  font-family: Oswald;
  font-size: 42px;
  font-weight: 500;
  letter-spacing: 0.95px;
  line-height: 0.57;
  text-transform: uppercase;
`;
